import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListQuiz from '../../components/quiz/list-quiz.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const QuizView = () => {
  const pageTitle = PAGE_TITLE_LIST.QUIZ;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListQuiz />
    </AppLayout>
  );
};

export default QuizView;
